import axios from "axios";

import baseDomain, {
  sendNotificationAPI,
} from "../../Constants/apiRoutes";

export const sendNotificationReq = (notificationid) => {
  return axios.post(`${baseDomain}${sendNotificationAPI}/${notificationid}`);
};